// 301-style redirects migrated from the old WordPress site.
// Implemented as pre-rendered HTML pages with <meta http-equiv="refresh">,
// canonical to the target, and noindex — the closest thing to a server 301
// in a static-hosted SPA. Google honors instant meta-refresh + canonical
// as a permanent redirect signal.

export const REDIRECTS: Record<string, string> = {
  "/servicios/crm": "/servicios/crm-implementacion",
  "/servicios/websites": "/servicios/web-corporativa",
  "/servicios-de-marketing-digital": "/",
  "/clientes-de-agencia-de-marketing-digital": "/casos-de-exito",
  "/blog-de-marketing-digital": "/blog",
  "/contacto-agencia-de-marketing-digital": "/contacto",
  "/planes-de-trabajo": "/precios",
  "/empleo-en-agencia-de-marketing": "/",
  "/servicios-de-marketing-digital/sitios-web": "/servicios/web-corporativa",
  "/servicios-de-marketing-digital/publicidad": "/servicios/publicidad-meta",
  "/servicios-de-marketing-digital/email-marketing": "/servicios/email-marketing",
  "/servicios-de-marketing-digital/estrategia": "/servicios/consultoria",
  "/servicios-de-marketing-digital/embudos": "/servicios/crm-implementacion",
  "/servicios-de-marketing-digital/crm-y-agenda": "/servicios/crm-implementacion",
  "/servicios-de-marketing-digital/creatividades": "/servicios/redes-sociales",
  "/servicios-de-marketing-digital/automatizacion": "/servicios/automatizacion",
  "/condiciones": "/terminos",
  "/terms-conditions": "/terminos",
  "/aviso-legal-sitio-web-marketing-digital": "/aviso-legal",
  "/politica-de-privacidad": "/privacidad",
  "/politica-de-cookies": "/cookies",
  "/personalizar-cookies": "/cookies",
  "/contacto-recibido": "/contacto",
  "/casos-de-exito/gonerstudio": "/casos/goner-studio",
  "/casos-de-exito/clinical-trainers": "/casos-de-exito",
  "/casos-de-exito/fuerza-terapeutica": "/casos-de-exito",
  "/casos-de-exito/tiendas-ideo": "/casos-de-exito",
  "/casos-de-exito/turismobcn": "/casos-de-exito",
  "/casos-de-exito/great-times-clothing": "/casos-de-exito",
  "/casos-de-exito/at-home-costa-del-sol": "/casos-de-exito",
  "/casos-de-exito/agroingenia": "/casos-de-exito",
  "/casos-de-exito/clinica-dentiart": "/casos-de-exito",
};

export const REDIRECT_SOURCES = Object.keys(REDIRECTS);
